<template>
  <v-sheet class="pa-4 my-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
    <template v-if="!aceptado">
      <div class="text-start">
        <v-checkbox
          v-model="declaraNoCoca"
          :label="$t('app.Labels.DeclareNoCoca')"
          hide-details
          density="compact"
        />
        <v-checkbox
          v-model="declaraNoMarihuana"
          :label="$t('app.Labels.DeclareNoMarihuana')"
          hide-details
          density="compact"
        />
      </div>
      <v-divider class="my-4"></v-divider>
      <div class="text-end">
        <v-btn class="text-none" :disabled="!declaraciones" @click="continuar" color="success" variant="flat" rounded>
          {{ $t('app.Buttons.Next') }}
        </v-btn>
      </div>
    </template>
    <template v-else>
      <p class="mb-4 text-medium-emphasis text-body-2">
        {{ $t('app.Labels.MegacentroMessage') }}
      </p>
      <v-divider class="mb-4"></v-divider>
      <div class="text-end">
        <v-btn class="text-none" @click="home" color="success" variant="flat" width="90" rounded>
          {{ $t('app.Buttons.Done') }}
        </v-btn>
      </div>
    </template>
  </v-sheet>
</template>
<script>
export default {
  name: 'MegacentroView',
  data() {
    return {
      declaraNoCoca: false,
      declaraNoMarihuana: false,
      aceptado: false,
    }
  },
  computed: {
    declaraciones() {
      return this.declaraNoCoca && this.declaraNoMarihuana
    }
  },
  methods: {
    continuar() {
      this.aceptado = true
    },
    home() {
      this.$store.commit('SET_VENTANA', 1)
      this.$router.push('/form')
    }
  }
}
</script>
